import React from 'react';
import { Navigate } from 'react-router-dom';
import { isHideoutUnlocked } from '../utils/hideoutAuth';

/**
 * /hideout 비밀번호 입력 없이 /todo, /daily, /study에 직접 접근한 경우
 * /hideout 으로 리다이렉트하는 라우트 가드.
 */
const RequireHideoutAuth: React.FC<{ children: React.ReactElement }> = ({ children }) => {
  if (!isHideoutUnlocked()) {
    return <Navigate to='/hideout' replace />;
  }
  return children;
};

export default RequireHideoutAuth;
